import { render, staticRenderFns } from "./MyProductPage.vue?vue&type=template&id=7c9a6bc0&scoped=true&"
import script from "./MyProductPage.vue?vue&type=script&lang=ts&"
export * from "./MyProductPage.vue?vue&type=script&lang=ts&"
import style0 from "./MyProductPage.vue?vue&type=style&index=0&id=7c9a6bc0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9a6bc0",
  null
  
)

export default component.exports